// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__2Bmck","title":"Images90_title__vr63p","images":"Images90_images__9hemg"};